class Addtocartbtn extends HTMLElement {
  constructor() {
    super()
    this.button = this
    this.button.addEventListener('click',this.fnAddtocart.bind(this))
  }
  fnAddtocart(event){
    let varaintId = parseInt(this.getAttribute('data-variant-id'));
    this.button.classList.add('btn--loading')
    let quantity = this.getAttribute('data-quantity')? parseInt(this.getAttribute('data-quantity')) :1;
    let formData = {
      id:varaintId,
      quantity:quantity
    }
      fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          // document.dispatchEvent(new Event('ajaxProduct:added'))
          if(window.SLIDECART){
            document.dispatchEvent(new Event('ajaxProduct:added'));
            window.SLIDECART_UPDATE();
            window.SLIDECART_OPEN();
            
          }
          else{
            document.dispatchEvent(new Event('ajaxProduct:added'))
            
          }
          this.button.classList.remove('btn--loading');
          return response.json();
        })
        .catch((error) => {
          this.button.classList.remove('btn--loading');
          console.error('Error:', error);
        });
  }
}
customElements.define("add-to-cart", Addtocartbtn);

// product Description Readmore Readless functionality

document.addEventListener("DOMContentLoaded", (event) => {
  const readmoreButton = document.getElementById('pr-de-readmore');
  const readlessButton = document.getElementById('pr-de-readless');
  const short_description = document.querySelector('.short_description');
  const full_description = document.querySelector('.full_description ');
  if(readmoreButton){
  readmoreButton.addEventListener('click',function(event){
    event.preventDefault();
    short_description.classList.add('hide');
    full_description.classList.remove('hide')
  })
  readlessButton.addEventListener('click',function(event){
    event.preventDefault();
    short_description.classList.remove('hide');
    full_description.classList.add('hide')
  });
  }

});







// Home page sticky baar
const elements = document.querySelectorAll(".page-content.page-content--product");
  const stickyBars = document.querySelectorAll(".sticky-bar-product");
 
  function checkElementsAtTop() {
    let activeId = null;
 
    elements.forEach(el => {
      const rect = el.getBoundingClientRect();
 
      // First element whose top is at/above 0 but still visible
      if (rect.top <= 0 && rect.bottom > 0 && activeId === null) {
        activeId = el.getAttribute("data-id");
      }
    });
 
    if (activeId) {
      // Remove active from all
      stickyBars.forEach(bar => bar.classList.remove("active-sticky"));
      // Add active to the matched one
      const target = document.querySelector('.sticky-bar-product[data-id="' + activeId + '"]');
      if (target) {
        target.classList.add("active-sticky");
      }
    }
  }
 
  // Run on page load
  checkElementsAtTop();
 
  // Run on scroll
  window.addEventListener("scroll", checkElementsAtTop);
 
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.add-cart').forEach(button => {
      button.addEventListener('click', function(e) {
          e.preventDefault();
          document.querySelector('.payment-buttons .add-to-cart')?.click(); 
      });
    });
  });